module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [((_vm.template === 'edit' || typeof _vm.template === 'undefined') && !_vm.field.readonly) ? [_c('label', {
    class: _vm.labelClass ? _vm.labelClass : 'u-label'
  }, [_vm._v("\n        " + _vm._s(_vm.field.label + (_vm.field.required ? '* ' : '')) + "\n      ")]), _vm._v(" "), _c('vue-dropzone', {
    ref: "dropzone",
    staticClass: "dropzone-component",
    class: 'qa-' + _vm.field.name + '-field',
    attrs: {
      "id": 'js-dropzone-' + _vm.field.name,
      "options": _vm.dropzoneOptions,
      "destroyDropzone": false
    },
    on: {
      "vdropzone-file-added": _vm.fileAdded,
      "vdropzone-removed-file": _vm.fileRemoved,
      "vdropzone-mounted": _vm.addExistingFiles
    }
  })] : _vm._e(), _vm._v(" "), (_vm.template === 'detail' || _vm.field.readonly) ? [_c('label', {
    class: _vm.labelClass ? _vm.labelClass : 'u-label'
  }, [_vm._v("\n        " + _vm._s(_vm.field.label + (_vm.field.required ? '* ' : '')) + "\n      ")]), _vm._v(" "), _vm._l((_vm.value), function(file) {
    return _c('div', {
      staticClass: "c-uploaded-file"
    }, [_c('span', {
      staticClass: "c-uploaded-file__title"
    }, [_vm._v("\n          " + _vm._s(file.filename) + "\n        ")]), _vm._v(" "), _c('div', {
      staticClass: "c-uploaded-file__buttons u-remove-on-mobile u-remove-on-tablet"
    }, [_c('button', {
      staticClass: "c-uploaded-file__buttons__button t-link",
      attrs: {
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          return _vm.showFile(file, true)
        }
      }
    }, [_vm._v("\n            " + _vm._s(_vm.$t('web.field_file_upload.download_button_desktop')) + "\n          ")]), _vm._v(" "), _c('button', {
      staticClass: "c-uploaded-file__buttons__button t-link",
      attrs: {
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          return _vm.showFile(file, false)
        }
      }
    }, [_vm._v("\n            " + _vm._s(_vm.$t('web.field_file_upload.open_button_desktop')) + "\n          ")])]), _vm._v(" "), _c('div', {
      staticClass: "c-uploaded-file__buttons u-remove-on-desktop"
    }, [_c('button', {
      staticClass: "c-uploaded-file__buttons__button t-link",
      attrs: {
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          return _vm.showFile(file, true)
        }
      }
    }, [_vm._v("\n            " + _vm._s(_vm.$t('web.field_file_upload.open_button_mobile')) + "\n          ")])])])
  })] : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7a152cba"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/fields/FieldFileUpload.vue
// module id = 554
// module chunks = 1